// FAQ on /guvenlik. Shared by the page and by entry-server.tsx, which writes the
// same questions into the prerendered FAQPage JSON-LD. Every answer states
// what the product does today (docs/onprem.md, apps/backend/docs/DATA_RESIDENCY.md).
type L = { tr: string; en: string };

export const SECURITY_FAQ: { q: L; a: L }[] = [
  {
    q: {
      tr: "Konuşmalarımız yapay zekâ eğitiminde kullanılıyor mu?",
      en: "Are our conversations used to train AI models?",
    },
    a: {
      tr: "Hayır. Cevapları yazan Claude modeli Anthropic'in API'si ve yedek olarak AWS Bedrock üzerinden çalışır; ikisi de API'den gelen veriyi model eğitiminde kullanmaz. Biz de konuşmalarınızla model eğitmiyoruz.",
      en: "No. The Claude model that writes replies runs through Anthropic's API, with AWS Bedrock as backup; neither uses API data to train models. We don't train models on your conversations either.",
    },
  },
  {
    q: {
      tr: "Verilerimiz Türkiye'de tutulabilir mi?",
      en: "Can our data stay in Turkey?",
    },
    a: {
      tr: "Bulutumuzda veriler AWS'nin Frankfurt bölgesinde (Almanya) saklanır, yapay zekâ cevapları ABD'de işlenir. Verinin Türkiye'den çıkmaması gerekiyorsa Hümo'yu kendi sunucunuza ya da Türkiye'deki bir veri merkezine kuruyoruz; yerel model seçilirse yapay zekâ da yurt dışına çıkmaz.",
      en: "In our cloud, data is stored in AWS's Frankfurt region (Germany) and AI replies are processed in the US. If data must not leave Turkey, we install Hümo on your own server or in a Turkish data centre; with a local model, the AI stays in the country too.",
    },
  },
  {
    q: {
      tr: "Bir müşterimiz verilerinin silinmesini isterse ne yaparız?",
      en: "A customer asks us to delete their data. What do we do?",
    },
    a: {
      tr: "Müşteri kartındaki \"Müşterinin verilerini sil\" ile. Bu düğmeyi yalnız yöneticiler görür ve müşterinin adı yazılmadan çalışmaz. Konuşmalar, mesajlar, dosyalar ve AI'ın o kişi hakkındaki notları silinir; işlem, kişisel veri içermeyen bir imha kaydıyla saklanır.",
      en: "Use \"Delete customer data\" on the customer card. Only admins see it, and it won't run until the customer's name is typed. Conversations, messages, files and the AI's notes on that person are deleted; the action is kept in a destruction record that holds no personal data.",
    },
  },
  {
    q: {
      tr: "Kendi sunucumuzda Instagram ve WhatsApp çalışır mı?",
      en: "Do Instagram and WhatsApp work on our own server?",
    },
    a: {
      tr: "Evet. Meta mesajları sunucunuza HTTPS ile iletir; bunun için sunucunuzun webhook adresinin internetten erişilebilir olması ve kurumunuzun kendi Meta uygulaması (Meta onayıyla) gerekir. E-posta kanalı ve ekibinizin kullandığı uygulama internete kapalı bir ağda da çalışır.",
      en: "Yes. Meta delivers messages to your server over HTTPS, so your server's webhook address must be reachable from the internet and your organisation needs its own Meta app (approved by Meta). Email and the app your team uses also work on a network closed to the internet.",
    },
  },
  {
    q: {
      tr: "Kendi sunucumuzda kurulumu ve güncellemeleri kim yapar?",
      en: "Who installs and updates Hümo on our own server?",
    },
    a: {
      tr: "Kurulumu BT ekibinizle birlikte yaparız. Güncelleme tek komutla yapılır ve öncesinde otomatik yedek alınır; bir sorun olursa son yedeğe dönülür. Sunucunuza erişimimiz yalnız sizin verdiğiniz kadardır.",
      en: "We install it together with your IT team. Updates take one command and take a backup first; if anything goes wrong, you roll back to it. We only have the access to your server that you give us.",
    },
  },
  {
    q: {
      tr: "Kendi sunucumuz için hangi donanım gerekir?",
      en: "What hardware does our own server need?",
    },
    a: {
      tr: "Claude ile (kendi Anthropic ya da AWS hesabınız) başlangıç önerimiz 4 çekirdek, 16 GB bellek ve 100 GB SSD'lik bir Linux sunucu. Tamamen yerel modelde ayrıca en az 24 GB belleğe sahip bir NVIDIA GPU gerekir.",
      en: "With Claude (your own Anthropic or AWS account) we suggest starting with a Linux server with 4 cores, 16 GB of memory and a 100 GB SSD. A fully local model also needs an NVIDIA GPU with at least 24 GB of memory.",
    },
  },
];
